import { render, staticRenderFns } from "./InForm6.vue?vue&type=template&id=dda20d48&scoped=true&"
import script from "./InForm6.vue?vue&type=script&lang=js&"
export * from "./InForm6.vue?vue&type=script&lang=js&"
import style0 from "./InForm6.vue?vue&type=style&index=0&id=dda20d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda20d48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
